import React from 'react'

import styled from 'styled-components'

const ClientSideOnlyLazy = React.lazy(() => import('./pdfClient.jsx'))

const Wrapper = styled.div`
  width: 99%;
  min-height: 30vh;
  overflow: hidden;
`

const PdfRenderer = ({ url }) => {
  const isSSR = typeof window === 'undefined'

  return (
    <Wrapper>
      <a
        href={url}
        className="p-2 underline"
        target="_blank"
        rel="noopener noreferrer">
        Ver PDF
      </a>
      {!isSSR && (
        <React.Suspense fallback={<div>Loading...</div>}>
          <ClientSideOnlyLazy url={url} />
        </React.Suspense>
      )}
    </Wrapper>
  )
}

export default PdfRenderer
